export const FIT_TO_SCREEN_PADDING = 100;
